export function decodeErrors (errors: Array<string>, enhancerFunction?: (...params: any) => any): any {
  if (enhancerFunction) {
    return Promise.reject(enhancerFunction(errors))
  }
}
